import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import { useModel as _useModel, mergeModels as _mergeModels } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "mark-status"
};
var _hoisted_2 = {
  key: 1
};
var _hoisted_3 = {
  class: "controls"
};
import { ref, watch } from 'vue';
import { MessagePlugin, DialogPlugin } from 'tdesign-vue-next';
import { getPaperPub, getRepeal } from '@/api/index-gai'; // 习练接口
import { validateNull } from '@/util/validate';
import { skipUrl as skipUrlOpen } from '@/util/util';
import useUserStore from '@/stores/modules/user';
import { storeToRefs } from 'pinia';
export default {
  __name: 'PracticeDialog',
  props: /*@__PURE__*/_mergeModels({
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }, {
    "visible": false,
    "visibleModifiers": {}
  }),
  emits: /*@__PURE__*/_mergeModels(['refresh'], ["update:visible"]),
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var _storeToRefs = storeToRefs(useUserStore()),
      appAliasUrl = _storeToRefs.appAliasUrl;
    var props = __props;
    var emit = __emit;
    var visible = _useModel(__props, 'visible', false);
    var tableData = ref([]);
    var isLoading = ref(false);
    var handleClose = function handleClose() {
      visible.value = false;
    };
    var tableListMenu = [{
      title: '班级',
      colKey: 'groupName',
      align: 'center',
      ellipsis: true,
      fixed: 'left'
    }, {
      title: '作答状态',
      colKey: 'respondenceStatus',
      align: 'center',
      ellipsis: true,
      width: 80
    }, {
      title: '批阅状态',
      colKey: 'markStatus',
      align: 'center',
      ellipsis: true,
      width: 80
    }, {
      title: '开始时间',
      colKey: 'startTime',
      align: 'center',
      ellipsis: true,
      cell: function cell(h, _ref2) {
        var row = _ref2.row;
        return row.startTime || '--';
      }
    }, {
      title: '结束时间',
      colKey: 'endTime',
      align: 'center',
      ellipsis: true,
      cell: function cell(h, _ref3) {
        var row = _ref3.row;
        return row.endTime || '--';
      }
    }, {
      title: '已布置',
      colKey: 'assignNum',
      align: 'center',
      ellipsis: true,
      width: '80px'
    }, {
      title: '未布置',
      colKey: 'unAssignNum',
      align: 'center',
      ellipsis: true,
      width: '80px'
    }, {
      title: '已提交',
      colKey: 'submitNum',
      align: 'center',
      ellipsis: true,
      width: '80px'
    }, {
      title: '未提交',
      colKey: 'unSubmitNum',
      align: 'center',
      ellipsis: true,
      width: '80px'
    }, {
      title: '操作',
      colKey: 'remark',
      ellipsis: true,
      align: 'center',
      fixed: 'right',
      width: 280
    }];

    /**
     * 获取习题详情
     */
    var initData = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _props$item, id, userId, res, _res$data, code, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!validateNull(props.item)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.p = 1;
              isLoading.value = true;
              _props$item = props.item, id = _props$item.id, userId = _props$item.userId;
              _context.n = 2;
              return getPaperPub(id, userId);
            case 2:
              res = _context.v;
              _res$data = res.data, code = _res$data.code, data = _res$data.data;
              if (code === 0) {
                tableData.value = data || [];
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              MessagePlugin.error('获取习题详情失败');
            case 4:
              _context.p = 4;
              isLoading.value = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }));
      return function initData() {
        return _ref4.apply(this, arguments);
      };
    }();
    watch(function () {
      return visible.value;
    }, function (val) {
      val && initData();
    }, {
      immediate: true,
      deep: true
    });
    // 作答状态
    var answerState = function answerState(val) {
      return arrayForValue(val, ['未发布', '未开始', '作答中', '已结束', '']);
    };
    // 批阅状态
    var markStatusList = function markStatusList(val) {
      return arrayForValue(val, ['未批阅', '批阅中', '批阅完成', '']);
    };

    /**
     * 数组转值
     */
    var arrayForValue = function arrayForValue(val, list) {
      return list[Number(val) || list.length - 1];
    };
    // 发布
    var releaseList = function releaseList() {
      var _props$item2 = props.item,
        id = _props$item2.id,
        resId = _props$item2.resId;
      var url = "".concat(appAliasUrl.value, "?prepareLesson=%2FreleasePage%3Fid%3D").concat(id, "%26resId%3D").concat(resId, "%26type%3Dpractice%26operate%3Drelease");
      skipUrlOpen(url, '_blank');
    };
    // 设置
    var setting = function setting(row) {
      var groupId = row.groupId;
      var _props$item3 = props.item,
        id = _props$item3.id,
        resId = _props$item3.resId;
      var url = "".concat(appAliasUrl.value, "?prepareLesson=%2FreleasePage%3Fid%3D").concat(id, "%26resId%3D").concat(resId, "%26groupId%3D").concat(groupId, "%26type%3Dpractice%26operate%3Dset");
      skipUrlOpen(url, '_blank');
    };
    // 撤销
    var repeal = function repeal(row) {
      var DialogInstance = DialogPlugin.confirm({
        theme: 'warning',
        header: '是否撤销当前发布？',
        confirmBtn: '是',
        cancelBtn: '否',
        onConfirm: function () {
          var _onConfirm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
            var res, code;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  _context2.n = 1;
                  return getRepeal(row.pubId);
                case 1:
                  res = _context2.v;
                  code = res.data.code;
                  MessagePlugin.closeAll();
                  DialogInstance.destroy();
                  MessagePlugin.warning(code === 0 ? '撤销发布成功！' : '操作失败！');
                  emit('refresh');
                case 2:
                  return _context2.a(2);
              }
            }, _callee2);
          }));
          function onConfirm() {
            return _onConfirm.apply(this, arguments);
          }
          return onConfirm;
        }()
      });
    };

    //批阅
    var handleClick = function handleClick(row) {
      var id = props.item.id;
      var url = "".concat(appAliasUrl.value, "?prepareLesson=/exercise/0/").concat(id, "/").concat(row.groupId);
      skipUrlOpen(url, '_blank');
    };
    //查看统计
    var viewStatistics = function viewStatistics(row) {
      var id = props.item.id;
      var url = "".concat(appAliasUrl.value, "?prepareLesson=/exercise/statistics/0/").concat(id, "/").concat(row.groupId);
      skipUrlOpen(url, '_blank');
    };
    return function (_ctx, _cache) {
      var _component_t_button = _resolveComponent("t-button");
      var _component_t_table = _resolveComponent("t-table");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createBlock(_component_t_dialog, {
        visible: visible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return visible.value = $event;
        }),
        class: "practice-dialog",
        width: "90%",
        header: "习练详情",
        destroyOnClose: "",
        footer: false,
        "on-close": handleClose
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_t_table, {
            class: "practice-table-box",
            data: tableData.value,
            "row-key": "id",
            maxHeight: "400px",
            bordered: "",
            loading: isLoading.value,
            columns: tableListMenu
          }, {
            respondenceStatus: _withCtx(function (_ref5) {
              var row = _ref5.row;
              return [_createElementVNode("div", null, _toDisplayString(answerState(row.respondenceStatus)), 1)];
            }),
            markStatus: _withCtx(function (_ref6) {
              var row = _ref6.row;
              return [row.pubId ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(markStatusList(row.markStatus)), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString('--')))];
            }),
            remark: _withCtx(function (_ref7) {
              var row = _ref7.row;
              return [_createElementVNode("div", _hoisted_3, [_createVNode(_component_t_button, {
                disabled: row.respondenceStatus === 0 || row.respondenceStatus === 1,
                variant: "text",
                theme: "primary",
                onClick: function onClick($event) {
                  return handleClick(row);
                }
              }, {
                default: _withCtx(function () {
                  return _toConsumableArray(_cache[1] || (_cache[1] = [_createTextVNode("批阅", -1)]));
                }),
                _: 1
              }, 8, ["disabled", "onClick"]), _createVNode(_component_t_button, {
                disabled: row.markStatus === 0,
                variant: "text",
                theme: "primary",
                onClick: function onClick($event) {
                  return viewStatistics(row);
                }
              }, {
                default: _withCtx(function () {
                  return _toConsumableArray(_cache[2] || (_cache[2] = [_createTextVNode("查看统计", -1)]));
                }),
                _: 1
              }, 8, ["disabled", "onClick"]), _createVNode(_component_t_button, {
                disabled: row.operateType === 1,
                variant: "text",
                theme: "primary",
                onClick: function onClick($event) {
                  return releaseList(row);
                }
              }, {
                default: _withCtx(function () {
                  return _toConsumableArray(_cache[3] || (_cache[3] = [_createTextVNode("发布", -1)]));
                }),
                _: 1
              }, 8, ["disabled", "onClick"]), _createVNode(_component_t_button, {
                disabled: row.operateType === 1 || row.respondenceStatus === 0,
                variant: "text",
                theme: "primary",
                onClick: function onClick($event) {
                  return repeal(row);
                }
              }, {
                default: _withCtx(function () {
                  return _toConsumableArray(_cache[4] || (_cache[4] = [_createTextVNode("撤销", -1)]));
                }),
                _: 1
              }, 8, ["disabled", "onClick"]), _createVNode(_component_t_button, {
                disabled: row.operateType === 1 || row.respondenceStatus === 0,
                variant: "text",
                theme: "primary",
                onClick: function onClick($event) {
                  return setting(row);
                }
              }, {
                default: _withCtx(function () {
                  return _toConsumableArray(_cache[5] || (_cache[5] = [_createTextVNode("设置", -1)]));
                }),
                _: 1
              }, 8, ["disabled", "onClick"])])];
            }),
            _: 1
          }, 8, ["data", "loading"])];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
};